export default {
  mask: {
    preview: {
      luminance: "亮度遮罩预览",
      rgb: "RGB 遮罩预览",
      dialogTitle: "遮罩预览",
    },
    tabs: {
      luminance: "亮度",
      rgb: "RGB",
    },
    channels: {
      rgb: "RGB",
      r: "R",
      g: "G",
      b: "B",
    },
    controls: {
      channel: "通道",
      zone: "分区",
      fineTune: "切换精细调节",
      fineTuneShow: "精细调节",
      fineTuneHide: "收起精调",
      hideMapping: "隐藏映射",
      showMapping: "显示映射",
      showOriginal: "显示原图",
      showGray: "显示灰度图",
      showLegend: "显示图例",
      renderMode: "切换渲染模式",
      renderModeWebgl: "WebGL（GPU）",
      renderModeCanvas: "Canvas 2D（CPU）",
      renderModeSwitch: "点击切换",
      showLabStats: "LAB 统计",
      showHslStats: "HSL 统计",
    },
    loadingPreview: "加载预览",
    retry: "重试",
    retryButton: "重试",
    previewMappingFailed: "当前图片映射预览失败，请稍后重试",
    zone: {
      global: "全局",
      blacks: "暗部",
      shadows: "阴影",
      midtones: "中间调",
      highlights: "高光",
      whites: "白场",
    },
    clipping: {
      title: "裁切/溢出",
      band: {
        hard: "Hard",
        near: "Near",
      },
      side: {
        left: "阴影侧",
        right: "高光侧",
      },
    },
    legend: {
      red: "红色通道",
      green: "绿色通道",
      blue: "蓝色通道",
      twoChannels: "双通道",
      allChannels: "全通道",
      solidColor: "纯色",
      redGreen: "红 + 绿",
      redBlue: "红 + 蓝",
      greenBlue: "绿 + 蓝",
    },
    slider: {
      slice: "切片",
      range: "范围",
      sliderMode: "滑块模式",
    },
  },
  hover: {
    rgb: "RGB",
    luminance: "亮度",
    placeholder: {
      title: "点测占位预览",
      description: "解锁后可查看当前光标位置的 RGB / LAB / HSL 精确数值。",
      locked: "待解锁",
      secondaryTitle: "更多色彩空间",
    },
    channel: {
      r: "R：",
      g: "G：",
      b: "B：",
      l: "L：",
    },
    hslHueWithName: "{value}（{name}）",
  },
  region: {
    previewTitle: "区域遮罩预览",
    controls: {
      region: "区域",
    },
    options: {
      foreground: "前景",
      background: "背景",
    },
  },
  zone: {
    global: "全局分析",
    zoneAnalysisTitle: "{zone} 分析",
    loading: "正在加载分析",
  },
  lab: {
    dialogTitle: "LAB 统计 - {zone}",
    toggleEn: "EN",
    toggleZh: "中",
    download: "下载统计数据",
    loadingAnalysis: "正在加载分析",
    loadingStatistics: "正在加载统计数据",
    empty: "该分区暂无统计数据",
    zone: {
      analysis: "分析",
      global: "全局",
      blacks: "暗部",
      shadows: "阴影",
      midtones: "中间调",
      highlights: "高光",
      whites: "白场",
    },
    metric: {
      title: "指标",
      channel: "{channel} 通道",
      mean: "均值",
      median: "中位数",
      mode: "众数",
      min: "最小值",
      max: "最大值",
      q1: "Q1（25%）",
      q3: "Q3（75%）",
      std: "标准差",
      variance: "方差",
      skewness: "偏度",
      kurtosis: "峰度",
    },
    section: {
      overall: "总体结论",
      global: "全局分析",
      partition: "分区分析",
    },
  },
  boxplot: {
    legend: {
      whisker: "顶端横线 / 底端横线",
      box: "箱体上边缘 / 下边缘",
      median: "箱体中间横线",
      mean: "箱体中叉号",
    },
  },
  hsl: {
    dialogTitle: "HSL 统计 - {zone}",
    download: "下载统计数据",
    loadingStatistics: "正在加载统计数据",
    empty: "该分区暂无统计数据",
    zone: {
      global: "全局",
      blacks: "暗部",
      shadows: "阴影",
      midtones: "中间调",
      highlights: "高光",
      whites: "白场",
    },
    metric: {
      title: "指标",
      channel: "{channel} 通道",
      mean: "均值",
      median: "中位数",
      mode: "众数",
      min: "最小值",
      max: "最大值",
      q1: "Q1（25%）",
      q3: "Q3（75%）",
      std: "标准差",
      variance: "方差",
      skewness: "偏度",
      kurtosis: "峰度",
    },
  },
  ai: {
    loading: "正在分析图像...",
    errorPrefix: "分析失败：",
  },
  histogram: {
    title: {
      rgb: "RGB 分布",
      tonal: "影调分布",
    },
    exportFile: "histogram_distribution.json",
    headers: {
      zone: "分区",
      sum: "总和",
      prop: "比例",
      avg: "平均值",
    },
    average: "平均值",
    pixels: "像素",
    tab: {
      rgb: "RGB",
      red: "红",
      green: "绿",
      blue: "蓝",
      gray: "灰度",
      luminosity: "亮度",
    },
    span: {
      short: "短",
      mid: "中",
      long: "长",
    },
  },
  chart: {
    defaultTitle: "影调直方图",
    loading: "加载图表",
    title: {
      rgbHistogram: "RGB 直方图",
      rgbOverlay: "RGB 通道叠加",
      redChannel: "红色通道",
      greenChannel: "绿色通道",
      blueChannel: "蓝色通道",
      gray: "灰度",
      luminosity: "亮度",
      brightness: "亮度（HSV）",
      lightness: "明度（LAB）",
    },
    description: {
      gray: "经典的单色投影，均衡考虑红绿蓝通道。呈现传统的影调分布，适合在无色彩干扰下分析黑白摄影的构图、明暗关系与画面结构。",
      luminosity:
        "测定曝光的黄金标准，通过重绿轻蓝的加权模拟人眼视觉。用于准确判断高光与暗部的实际视觉溢出，确保后期曝光调整符合真实视觉观感。",
      brightness:
        "基于最大通道值的纯数学表征，对高饱和鲜艳色彩极度敏感。最适合在 HSL 面板中精确定位特定色彩范围或隔离高饱和色调，而非用于评估整体曝光。",
      lightness:
        "专为感知均匀设计，将明暗与色彩完全解耦。非常适合进行高级影调曲线微调，可在不引起色偏或人为过度饱和的情况下，完美控制画面的反差与影调细节。",
    },
    legend: {
      red: "R 通道",
      green: "G 通道",
      blue: "B 通道",
    },
    axis: {
      intensity: "强度级别",
      frequency: "频次",
    },
    controls: {
      reset: "重置",
      toggleChannels: "切换通道",
    },
  },
  palette: {
    tabs: {
      global: "全局",
    },
    labels: {
      hex: "HEX",
      rgb: "RGB",
    },
    distribution: {
      hue: "色相分布",
      saturation: "饱和度分布",
      lightness: "明度分布",
    },
    harmony: {
      title: "色彩和谐度",
      wheel: "和谐色轮",
      legendDots: "圆点表示主导色，相对大小代表权重。",
      legendLines: "虚线代表色相关系。",
      typeLabel: "类型：",
      relationshipsLabel: "关系：",
      distributionLabel: "分布：",
      types: {
        complementary: "互补",
        triadic: "三分",
        analogous: "类比",
        splitComplementary: "分裂互补",
        tetradic: "四分",
        square: "方形",
        monochrome: "单色",
        neutral: "中性",
        custom: "自定义",
      },
      summaries: {
        complementary: "对比强烈，带来清晰有力的视觉冲击。",
        triadic: "三色均衡，形成活泼有序的搭配。",
        analogous: "相邻色过渡平滑，氛围统一。",
        splitComplementary: "对比鲜明但更柔和。",
        tetradic: "双互补组合，色彩丰富有层次。",
        square: "四色均分，氛围大胆多样。",
        monochrome: "单一色系，变化细腻。",
        neutral: "低饱和，安静内敛。",
        custom: "未形成明显几何结构，色相分布较散。",
      },
      descriptions: {
        customStrong: "色彩关系较稳固，但未形成经典几何结构。",
        customBalanced: "整体较平衡，但缺少明确的和谐结构。",
        customWeak: "色相结构松散，如需可进一步整理。",
        strong: "色彩和谐度优秀，关系均衡。",
        good: "色彩和谐度良好，可做细微调整。",
        weak: "色彩和谐度偏弱，建议优化。",
      },
    },
    hueRanges: {
      red: "红",
      orange: "橙",
      yellow: "黄",
      yellowGreen: "黄绿",
      green: "绿",
      greenCyan: "绿青",
      cyan: "青",
      cyanBlue: "青蓝",
      blue: "蓝",
      blueMagenta: "蓝紫",
      magenta: "紫",
      magentaRed: "紫红",
    },
    saturationRanges: {
      low: "低",
      mediumLow: "偏低",
      medium: "中",
      mediumHigh: "偏高",
      high: "高",
    },
    lightnessRanges: {
      veryDark: "很暗",
      dark: "偏暗",
      medium: "中等",
      light: "偏亮",
      veryLight: "很亮",
    },
    statistics: {
      title: "全局统计",
      colorCount: "颜色数量",
      mainColorProportion: "主色占比",
      colorfulness: "色彩丰富度",
      averageSaturation: "平均饱和度",
      averageLightness: "平均明度",
      contrastRatio: "对比度",
    },
    empty: "暂无色彩数据",
    copied: "已复制",
  },
};
